import { opportunitySyncProfilesService } from '@/services/opportunity-sync-profiles.service';
import axios from 'axios';

const initialState = () => ({
  similarOpportunities: [],
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  searchSimilarOpportunities({ commit }, { syncProfileId, searchQuery }) {
    commit('SEARCH_OPPORTUNITIES');
    return opportunitySyncProfilesService.searchOpportunities({ syncProfileId, searchQuery }).then(
      (response) => {
        return commit('SUCCESS_SEARCH_OPPORTUNITIES', response);
      },
      (error) => {
        if (!axios.isCancel(error)) {
          throw error;
        }
      },
    );
  },
};

const mutations = {
  SEARCH_OPPORTUNITIES(state) {
    state.status = {
      error: null,
      resolved: false,
      rejected: false,
      pending: true,
    };
    state.similarOpportunities = [];
  },
  SUCCESS_SEARCH_OPPORTUNITIES(state, results) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.similarOpportunities = results;
  },
  ERROR(state, error) {
    state.status = {
      error,
      pending: false,
      resolved: false,
      rejected: true,
    };
  },
};

const getters = {
  similarOpportunities: (state) => state.similarOpportunities,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const opportunitySyncProfile = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
